import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Alert } from 'react-bootstrap';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirm: ''
  });
  const [loading, setLoading] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState({
    loading: true,
    allowed: true,
    error: null
  });
  const { register } = useAuth();
  const navigate = useNavigate();

  const { firstName, lastName, email, password, passwordConfirm } = formData;
  
  // Kayıt durumunu kontrol et
  useEffect(() => {
    const checkRegistrationStatus = async () => {
      try {
        const { data } = await axios.get('/api/site-settings/registration-status');
        
        if (data.success) {
          setRegistrationStatus({
            loading: false,
            allowed: data.allowRegistration,
            error: null
          });
        }
      } catch (error) {
        setRegistrationStatus({
          loading: false,
          allowed: false,
          error: 'Kayıt durumu kontrol edilirken bir hata oluştu'
        });
      }
    };
    
    checkRegistrationStatus();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== passwordConfirm) {
      alert('Şifreler eşleşmiyor');
      return;
    }
    
    setLoading(true);
    
    const success = await register(formData);
    
    if (success) {
      navigate('/');
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <Card>
        <Card.Body>
          <h2 className="auth-title">Kayıt Ol</h2>
          
          {registrationStatus.loading ? (
            <div className="text-center my-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
              </div>
              <p className="mt-2">Kayıt durumu kontrol ediliyor...</p>
            </div>
          ) : registrationStatus.error ? (
            <Alert variant="danger" className="my-3">
              {registrationStatus.error}
            </Alert>
          ) : !registrationStatus.allowed ? (
            <Alert variant="warning" className="my-3">
              <p className="mb-0">Şu anda yeni kayıtlar kapalıdır. Lütfen daha sonra tekrar deneyiniz.</p>
              <p className="mb-0 mt-2">
                <Link to="/login">Giriş sayfasına dön</Link>
              </p>
            </Alert>
          ) : (
            <Form onSubmit={handleSubmit} className="auth-form">
            <Form.Group className="mb-3">
              <Form.Label>Ad</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                value={firstName}
                onChange={handleChange}
                placeholder="Adınızı giriniz"
                required
                autoFocus
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Soyad</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                value={lastName}
                onChange={handleChange}
                placeholder="Soyadınızı giriniz"
                required
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>E-posta</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={email}
                onChange={handleChange}
                placeholder="E-posta adresinizi giriniz"
                required
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Şifre</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={password}
                onChange={handleChange}
                placeholder="Şifrenizi giriniz"
                required
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Şifre Tekrar</Form.Label>
              <Form.Control
                type="password"
                name="passwordConfirm"
                value={passwordConfirm}
                onChange={handleChange}
                placeholder="Şifrenizi tekrar giriniz"
                required
                autoComplete="off"
              />
            </Form.Group>

            <Button 
              variant="primary" 
              type="submit" 
              className="w-100 mt-3" 
              disabled={loading}
            >
              {loading ? 'Kayıt Yapılıyor...' : 'Kayıt Ol'}
            </Button>
          </Form>
          )}
        </Card.Body>
      </Card>
      <Link to="/login" className="auth-link">
        Zaten hesabınız var mı? Giriş yapın
      </Link>
    </div>
  );
};

export default Register;
